
export function getLocalData(key) {
    return JSON.parse(localStorage.getItem(key));
}

export function saveLocalData(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

export function removeLocalData(key) {
    localStorage.removeItem(key);
}

export function clearLocalData() {
    localStorage.clear();
}